import {
    Card,
    CardBody,
    CardFooter,
    Typography,
} from "@material-tailwind/react";
import React from "react";

import { BiBookReader } from "react-icons/bi";
import { FaWallet } from "react-icons/fa";


const DashboardCard = ({ CTA = "box", value = 0, Comp = "" }) => {

    if (Comp === "Book") {
        return (
            <Card className="m-3 min-w-[5vw] w-max shadow flex flex-col justify-center hover:scale-105 align-middle hover:shadow-black">
                <CardFooter className="text-center flex justify-center">
                    <BiBookReader className="bg-blue-300 text-center p-2 w-[60px] h-[60px] text-white rounded-full" />
                </CardFooter>
                <CardBody>
                    <Typography className="text-xl text-center">
                        {CTA}
                    </Typography>
                    <Typography className="text-center text-2xl">
                        {value}
                    </Typography>
                </CardBody>
            </Card>
        );
    }

    if (Comp === "History") {
        return (
            <Card className="m-3 w-max shadow flex flex-col justify-center align-middle hover:shadow-black hover:scale-105">
                <CardFooter className="text-center flex justify-center ">
                    <FaWallet className="bg-indigo-300 text-center p-2 w-[60px] h-[60px] text-white rounded" />
                </CardFooter>
                <CardBody>
                    <Typography className="text-xl text-center">
                        {CTA}
                    </Typography>
                    <Typography className="text-center text-2xl">
                        {value}
                    </Typography>
                </CardBody>
            </Card>
        );
    }
    return (
        <Card className="m-3 hover:shadow-black min-w-[5vw] w-max shadow flex flex-col justify-center align-middle hover:scale-105">
            <CardFooter className="text-center flex justify-center">
                <BiBookReader className="bg-blue-300 text-center p-2 w-[60px] h-[60px] text-white rounded-full" />
            </CardFooter>
            <CardBody>
                <Typography className="text-xl text-center">
                    {CTA}
                </Typography>
                <Typography className="text-center text-2xl">
                    {value}
                </Typography>
            </CardBody>
        </Card>
    );
}

export default DashboardCard;